import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminSettings() {
  const [p, setP] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/pricing").then(r => setP(r.data)); }, []);
  const upd = (k) => (e) => setP({ ...p, [k]: e.target.type === "number" ? Number(e.target.value) : e.target.value });
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/pricing", p);
      setP(data);
      toast.success("Pricing saved");
    } catch { toast.error("Could not save"); }
    finally { setSaving(false); }
  };
  if (!p) return <div className="text-center text-[#475569]">Loading…</div>;
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Settings</div><h1 className="cm-h2">Pricing configuration</h1><p className="cm-body mt-1 text-sm">All prices are configurable. Doctor payouts and platform take are derived from these values.</p></div>
      <div className="cm-card grid sm:grid-cols-2 gap-4">
        <div><label className="cm-label">Currency</label><input className="cm-input" value={p.currency||"GBP"} onChange={upd("currency")} data-testid="settings-currency"/></div>
        <div/>
        <div><label className="cm-label">General price (patient pays)</label><input className="cm-input" type="number" step="0.5" value={p.general_price} onChange={upd("general_price")} data-testid="settings-general-price"/></div>
        <div><label className="cm-label">Specialist price (patient pays)</label><input className="cm-input" type="number" step="0.5" value={p.specialist_price} onChange={upd("specialist_price")} data-testid="settings-specialist-price"/></div>
        <div><label className="cm-label">Doctor payout — general</label><input className="cm-input" type="number" step="0.5" value={p.doctor_general_payout} onChange={upd("doctor_general_payout")} data-testid="settings-general-payout"/></div>
        <div><label className="cm-label">Doctor payout — specialist</label><input className="cm-input" type="number" step="0.5" value={p.doctor_specialist_payout} onChange={upd("doctor_specialist_payout")} data-testid="settings-specialist-payout"/></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="cm-card"><div className="cm-eyebrow">Platform take — general</div><div className="text-2xl font-bold text-[#1a2b4a] mt-1">{p.currency||"GBP"} {(p.general_price - p.doctor_general_payout).toFixed(2)}</div></div>
        <div className="cm-card"><div className="cm-eyebrow">Platform take — specialist</div><div className="text-2xl font-bold text-[#1a2b4a] mt-1">{p.currency||"GBP"} {(p.specialist_price - p.doctor_specialist_payout).toFixed(2)}</div></div>
      </div>
      <button className="cm-btn-primary" onClick={save} disabled={saving} data-testid="settings-save"><Save size={14}/> {saving?"Saving…":"Save pricing"}</button>
    </div>
  );
}
